import { useState, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { API_URL, scroll, getValFromLS } from "../../helpers";

import Hdg from "../../components/Hdg";
import Alert from "../../components/Alert";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Nav from "../Nav";

const Delete = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [, setErrors] = useState([]);
	const [, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const { str } = useParams();
	const formElement = useRef();
	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardHotelEditInit`);
			const params = {
				id: auth.id ? auth.id : "",
				q: str ? str : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });

					setDetails({
						...json,
					});

					setNames((names) => ({
						...names,
						bed: json.bed,
						name: json.name,
						email: json.email,
					}));

					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardHotelDelete`);
		let data = new FormData();

		data.append("roomId", details.roomId);
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: `/dashboard/hotel`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Dashboard" />
						<p>Use this form to delete a room request.</p>

						<table
							className="approved assigned"
							style={{ marginTop: "15px", marginBottom: "15px" }}
						>
							<thead>
								<tr>
									<th className="center" style={{ width: "15%" }}>
										ID
									</th>
									<th className="center" style={{ width: "15%" }}>
										Hotel
									</th>
									<th className="center" style={{ width: "30%" }}>
										Occupant
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="center">{details.roomId}</td>
									<td className="center">{details.hotel}</td>
									<td className="center">{`${details.name} (${details.email})`}</td>
								</tr>
							</tbody>
						</table>

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Delete a Room Request
							</h4>

							<p>
								Click below to delete this room request. Please note that
								deleted requests cannot be recovered.
							</p>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/dashboard/hotel"
										left="Back"
										submit="Delete Room Request"
									/>
								</div>
							</div>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={0} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Delete;
